import { mapGetters } from "vuex";
import Modal from '../../components/modal';

export default {
  beforeMount() {
    this.$store.commit('pageLoad')
  },
  mounted () {
    this.fetchItem().then(() => {
      this.$store.commit('isPageLoad')
    })
  },
  methods: {
    fetchItem (ssr = false) {
      return this.$store.dispatch('fetchCurrentPage', {page: 'narcologist', ssr: ssr})
    },
    edit(code, block) {
      if(this.getUser) {
        this.$store.commit('setEditor',
          {code: code, block: block, page: 'narcologist' }
        )
      }
    }
  },
  computed: {
    ...mapGetters(["getCurrentPage", "getUser"])
  },
  components: {
    Modal,
  },
};


// WEBPACK FOOTER //
// ./src/pages/Narcologist/narcologist.js